<template>
  <FocusTrap>
    <div class="card">

      <div class="card-header header-elements-inline" style="background-color: whitesmoke; padding: 10px;">
        <h5 v-if="labour.id == 0" class="card-title">Labour Creation</h5>
        <h5 v-if="labour.id > 0" class="card-title"> Labour Updation</h5>
        <div class="header-elements">
          <div class="list-icons">
            <a class="list-icons-item" data-action="reload" ></a>
            <a class="list-icons-item" data-action="remove" @click="closeWindow"></a>
          </div>
        </div>
      </div>


      <div class="card-body">
        <p/>
      <form action="#">

        <div class="form-group row">
          <label class="col-md-2 col-form-label">Name:</label>
          <div class="col-md-10">
            <input  id="txtname" ref="txtname"  type="text" class="form-control" placeholder="Enter Labour Name here..." maxlength="100" v-if="labour" v-model="labour.name" autocomplete="off" >
          </div>
        </div>

        <div class="form-group row">
          <label class="col-md-2 col-form-label">Type:</label>
          <div class="col-md-10">
            <select class="form-control" required="" v-if="labour" v-model="labour.type">
              <option value="1" >-</option>
              <option value="2" selected>MASON</option>
              <option value="3">ELECTRICIAN</option>
              <option value="4">NAIKAR</option>
              <option value="5">CENTRING</option>
            </select>
          </div>
        </div>

        <div class="form-group row">
          <label class="col-md-2 col-form-label">Mobile:</label>
          <div class="col-md-10">
            <input type="number" class="form-control" placeholder="Enter Mobile here..." max="9999999999"  v-if="labour" v-model="labour.mobile">
          </div>
        </div>

      </form>
    </div>

    <div class="card-footer">
      <div class="text-right" >
        <button type="button" class="btn btn-primary" @click="saveDocument" >Save<i class="icon-paperplane ml-2"></i></button>
      </div>
    </div>
  </div>
  </FocusTrap>
</template>

<script>
import {userService} from '@/store/auth-header.js'
import moment from 'moment-timezone'
import { store } from '@/store/store.js'
export default {
  name: 'LabourForm',
  store,
  data () {
    return {
      labour: JSON.parse('{"id":0,"type":1,"name":"","mobile":""}')
    }
  },
  props: {
    mylabour: {
      type: Object,
      required: true,
      default: JSON.parse('{"id":0,"type":1,"name":"","mobile":""}')
    }
  },
  beforeMount () {
    this.labour = this.mylabour; // save props data to itself's data and deal with tms
  },

  component: {

  },
  created () {
    this.$data.labour = JSON.parse('{"id":0,"type":1,"name":"","mobile":""}')
  },
  mounted () {
    const self = this;
    //$('#txtname').focus();
    self.$refs.txtname.focus();
  },
  methods: {
    closeWindow(){
      this.$emit('labour_window_closed');
      this.labour = JSON.parse('{"id":0,"type":1,"name":"","mobile":""}');
    },
    clear(){
      this.$data.labour = JSON.parse('{"id":0,"type":1,"name":"","mobile":""}');
    },

    saveDocument(){
      const self = this;

      if(self.$data.labour.name.trim().length < 1){
        alert("Invalid Name");
        return
      }

      self.$data.labour.type = parseInt(self.$data.labour.type);

      const requestOptions = {
        method:  (self.$data.labour.id == 0 ? 'POST' : 'PUT'),
        mode:"cors",
        headers: userService.authHeader(),
        body: JSON.stringify(self.$data.labour)
      };

      // console.log(JSON.stringify(self.$data.labour));

      fetch(`${process.env.VUE_APP_ROOT_API}api/bms/labour`,requestOptions).then(userService.handleResponse).then(function (resp) {
        if(resp.ok) {
          self.$emit('labour_saved', resp.data);
          swal ( { title: "Success!" ,  text: resp.msg, type: "success"} );
          self.labour = JSON.parse('{"id":0,"type":1,"name":"","mobile":""}');
        } else {
          swal ( { title: "Oops!" ,  text: resp.msg, type:  "error"} );
        }
      }).catch(function (err) {
        swal ( { title: "Oh noes!" ,  text: err.toString(), type:  "error"});
      });
    }
  }
}
</script>

<style scoped>
  input:focus {
    background: #feff00;

  }

  textarea:focus {
    background: #feff00;

  }

  select:focus {
    background: #feff00;
  }

  button:focus {
    background: #feff00;
    color: #0a0a0a!important;
  }

  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  /* Firefox */
  input[type=number] {
    -moz-appearance: textfield;
  }
</style>
